import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import actions from '../../redux/actions';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Button from '../../common/components/Button/Button';
import {buildQuoteItems, isValidEmail as validateEmail} from './quoteEmail.utils';
import './CreateAttention.scss';

const SendQuoteForm = (props) => {
    const {
        affiliateData,
        affiliateSelected,
        attentionsSelected,
        provider,
        branch,
        sendQuoteEmailState,
        sendQuoteEmail,
        cleanSendQuoteEmailState,
    } = props;

    useEffect(() => {
        cleanSendQuoteEmailState();
        // eslint-disable-next-line
    }, []);

    const affiliate = affiliateData?.[0];
    const [email, setEmail] = useState(affiliate?.email || '');
    const trimmedEmail = email.trim();
    const isValidEmail = validateEmail(trimmedEmail);

    const handleSend = () => {
        sendQuoteEmail({
            email: trimmedEmail,
            patient: {
                fullName: affiliate.fullName,
                document: affiliateSelected?.searchTag === 'document' ? affiliate.documentNumber : null,
                affiliateNumber: affiliateSelected?.searchTag === 'document' ? null : affiliate.affiliateNumber,
                medicalCoverage: affiliate.medicalCoverage || null,
            },
            provider: provider || null,
            branch: branch || null,
            items: buildQuoteItems(attentionsSelected),
        });
    };

    // Card propia y opcional debajo de la tabla. Finalizar queda afuera, en ThirdStep.
    if (sendQuoteEmailState.success) {
        return (
            <div className={'send-quote-card'}>
                <div className={'send-quote-sent'}>
                    <span className={'send-quote-sent-icon'} aria-hidden>✓</span>
                    <p className={'body-1 c-text-base'}>
                        Cotización enviada a <b>{trimmedEmail}</b>
                    </p>
                    <button type={'button'} className={'send-quote-link body-2'}
                            onClick={cleanSendQuoteEmailState}>Reenviar</button>
                </div>
            </div>
        );
    }

    return (
        <div className={'send-quote-card'}>
            <div className={'send-quote-header'}>
                <p className={'subtitle-1 v2-c-text-title'}>Enviar cotización por email</p>
                <p className={'body-2 c-text-subtitle'}>
                    Le enviamos al paciente el detalle de esta cotización.
                </p>
            </div>
            <div className={'send-quote-input-row'}>
                <CustomInput
                    label={'Email del paciente'}
                    placeholder={'email@ejemplo.com'}
                    value={email}
                    onChange={setEmail}
                    disabled={sendQuoteEmailState.loading}
                    type={'text'}
                />
                <Button size={'medium'} onClick={handleSend}
                        disabled={!isValidEmail || sendQuoteEmailState.loading || !attentionsSelected?.length}>
                    {sendQuoteEmailState.loading ? 'Enviando...' : 'Enviar'}
                </Button>
            </div>
            {!affiliate?.email && (
                <p className={'body-3 c-text-subtitle'}>
                    El paciente no tiene un email cargado. Ingréselo para enviar la cotización.
                </p>
            )}
            {email && !isValidEmail && (
                <p className={'body-3 c-text-subtitle'}>Ingrese un email válido</p>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    affiliateData: state.home.affiliates,
    affiliateSelected: state.home.affiliateSelected,
    attentionsSelected: state.home.attentionsSelected,
    sendQuoteEmailState: state.home.sendQuoteEmailState,
});

const mapDispatchToProps = (dispatch) => ({
    sendQuoteEmail: (body) => dispatch(actions.home.sendQuoteEmailRequest(body)),
    cleanSendQuoteEmailState: () => dispatch(actions.home.cleanSendQuoteEmailState()),
});

SendQuoteForm.propTypes = {
    affiliateData: PropTypes.array,
    affiliateSelected: PropTypes.object,
    attentionsSelected: PropTypes.array,
    provider: PropTypes.string,
    branch: PropTypes.string,
    sendQuoteEmailState: PropTypes.object,
    sendQuoteEmail: PropTypes.func,
    cleanSendQuoteEmailState: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SendQuoteForm);
